var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewDesktopFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View Desktop Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M16.4577 2.5C17.4501 2.5 18.2624 3.27097 18.3284 4.24663L18.3327 4.375V13.1269C18.3327 14.1193 17.5617 14.9316 16.5861 14.9976L16.4577 15.0019L12.9162 15.0017V17.0833L14.3753 17.0837C14.7205 17.0837 15.0003 17.3635 15.0003 17.7087C15.0003 18.0251 14.7652 18.2866 14.4601 18.328L14.3753 18.3337H5.62533C5.28015 18.3337 5.00033 18.0539 5.00033 17.7087C5.00033 17.3923 5.23545 17.1308 5.54052 17.0894L5.62533 17.0837L7.08283 17.0833V15.0017L3.54199 15.0019C2.54961 15.0019 1.73729 14.2309 1.67132 13.2553L1.66699 13.1269V4.375C1.66699 3.38261 2.43796 2.5703 3.41362 2.50433L3.54199 2.5H16.4577ZM11.6653 15.0017H8.33199L8.33283 17.0837H11.6662L11.6653 15.0017ZM15.4206 5H7.91699C7.68687 5 7.50033 5.18655 7.50033 5.41667V12.0854C7.50033 12.3155 7.68687 12.502 7.91699 12.502H15.4206C15.6507 12.502 15.8372 12.3155 15.8372 12.0854V5.41667C15.8372 5.18655 15.6507 5 15.4206 5ZM6.24978 5H4.58317C4.35305 5 4.16651 5.18655 4.16651 5.41667V12.0854C4.16651 12.3155 4.35305 12.502 4.58317 12.502H6.24978C6.4799 12.502 6.66645 12.3155 6.66645 12.0854V5.41667C6.66645 5.18655 6.4799 5 6.24978 5Z",
    fill: "#1D72E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDesktopFilled);
export default __webpack_public_path__ + "static/media/view_desktop_filled.4267ac81b0ee4c53ee56f51937cf98e9.svg";
export { ForwardRef as ReactComponent };